import React, { useState } from "react";
import { MenuItem, TextField } from "@mui/material";
import { Customer } from "../../../../data/entities";
import { InfoBoxTitle, InfoBoxWrapper } from "../Styled";

// The customer API currently returns an ordered list without an is_default flag.
// Use its first saved delivery address for new orders only.
export const getInitialDeliveryAddress = (customer: Customer) =>
    customer.delivery_addresses?.[0]?.address || "";

interface Props {
    customer?: Customer | null;
    value: string;
    onChange: (value: string) => void;
    isView?: boolean;
}

const DeliveryAddress = ({ customer, value, onChange, isView = false }: Props) => {
    const addresses = customer?.delivery_addresses || [];
    const [custom, setCustom] = useState(false);
    const matchedIndex = addresses.findIndex((item) => item.address === value);
    const isCustom = custom || Boolean(value && matchedIndex === -1);
    const selected = isCustom ? "other" : matchedIndex >= 0 ? String(matchedIndex) : "";

    return (
        <InfoBoxWrapper as="section" aria-label="Thông tin chung">
            <InfoBoxTitle>Thông tin chung</InfoBoxTitle>
            {isView ? (
                <TextField
                    label="Địa chỉ giao hàng"
                    value={value}
                    placeholder="Chưa có địa chỉ giao hàng"
                    InputProps={{ readOnly: true }}
                    fullWidth
                    multiline
                    size="small"
                />
            ) : (
                <>
                    <TextField
                        select
                        label="Địa chỉ giao hàng"
                        value={selected}
                        required
                        fullWidth
                        size="small"
                        helperText={!addresses.length ? "Khách hàng chưa có địa chỉ giao hàng. Chọn Nhập địa chỉ khác." : undefined}
                        onChange={(event) => {
                            const next = event.target.value;
                            setCustom(next === "other");
                            onChange(next === "other" ? "" : addresses[Number(next)].address);
                        }}
                    >
                        {addresses.map((item, index) => (
                            <MenuItem key={item.id || index} value={String(index)} sx={{ whiteSpace: "normal" }}>
                                {item.label} — {item.address}
                            </MenuItem>
                        ))}
                        <MenuItem value="other">Nhập địa chỉ khác</MenuItem>
                    </TextField>
                    {isCustom && (
                        <TextField
                            label="Địa chỉ giao hàng khác"
                            value={value}
                            onChange={(event) => onChange(event.target.value)}
                            required
                            fullWidth
                            multiline
                            size="small"
                            helperText="Địa chỉ này chỉ lưu trên đơn hàng, không thêm vào danh sách của khách hàng."
                        />
                    )}
                </>
            )}
        </InfoBoxWrapper>
    );
};

export default DeliveryAddress;
